/** Recover only an established funnel on continuation links; fresh entries stay plain. */
export function restoreFunnelSearch(pathname: string, search: string, savedCode: string | null) {
  const query = new URLSearchParams(search);
  const path = pathname.replace(/\/+$/u, '') || '/';
  if (query.has('qz') || query.get('flow') === 'organic' || !['fc1','tst1'].includes(savedCode ?? '')) return search;
  if (['/','/start'].includes(path) && !query.has('code')) return search;
  if (!/^\/(?:start\/q\d+|guest\/[^/]+|auth\/callback|checkout(?:\/[^/]+)?|)$/u.test(path)) return search;
  query.set('qz', savedCode!);
  return `?${query}`;
}

/** No query string can enable this on production, a tunnel, or the existing dev server. */
export function isGuestCheckoutPreview(dev: boolean, flag: string | undefined, hostname: string, search: string) {
  return dev && flag === '1'
    && ['localhost', '127.0.0.1', '[::1]'].includes(hostname)
    && new URLSearchParams(search).get('qz') === 'tst1';
}

/** Local review only: plain organic URLs use the dedicated sandbox backend. */
export function isOrganicGuestCheckoutPreview(options: {dev:boolean;flag?:string;hostname:string;search:string;backendUrl?:string}) {
  const query = new URLSearchParams(options.search);
  return options.dev && options.flag === '1'
    && ['localhost', '127.0.0.1', '[::1]'].includes(options.hostname)
    && !query.has('qz') && query.get('flow') !== 'account'
    && options.backendUrl === 'https://uwbhxqxqfruwzssqarud.supabase.co';
}

/** Released organic and fc1 funnels; explicit account checkout stays available. */
export function isGuestCheckoutRelease(options: {flag?:string;hostname:string;search:string;backendUrl?:string;guestBackendUrl?:string}) {
  const query = new URLSearchParams(options.search);
  if (options.flag !== '1' || !['focuscorp.app','www.focuscorp.app'].includes(options.hostname)
    || (query.has('qz') && query.get('qz') !== 'fc1') || query.get('flow') === 'account') return false;
  try {
    const primary = new URL(options.backendUrl || '');
    const guest = new URL(options.guestBackendUrl || '');
    return primary.protocol === 'https:' && primary.origin === guest.origin
      && primary.hostname.endsWith('.supabase.co')
      && primary.hostname !== 'uwbhxqxqfruwzssqarud.supabase.co';
  } catch { return false; }
}

/** Public test entry shares the released UI, but never its account/payment backend. */
export function isGuestCheckoutTestRelease(options: {flag?:string;hostname:string;search:string;testBackendUrl?:string}) {
  const query = new URLSearchParams(options.search);
  return options.flag === '1' && ['focuscorp.app','www.focuscorp.app'].includes(options.hostname)
    && query.get('qz') === 'tst1' && query.get('flow') !== 'account'
    && options.testBackendUrl === 'https://uwbhxqxqfruwzssqarud.supabase.co';
}
